.list {
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-1x);
    align-items: center;
}

.header {
    background-color: var(--bi-neutral-5);
    padding: var(--bi-scale-3x) calc((100dvw - 100%) / 2);
    width: 100dvw;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: var(--bi-scale-2x);

    > h2 {
        color: var(--bi-neutral-95);
        font-family: 'museo-sans', Arial, sans-serif;
        font-size: 1.25rem;
        font-weight: 700;
        line-height: 1.3;
    }
}

.results {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-3x);
    margin-bottom: var(--bi-scale-4x);
}
